export default __webpack_public_path__ + "static/media/blue dot button.31c06f2f.svg";